import { render, staticRenderFns } from "./CurrencyHelpList.vue?vue&type=template&id=506c8f96&"
import script from "./CurrencyHelpList.vue?vue&type=script&lang=js&"
export * from "./CurrencyHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports